import LightPlusBtn from "components/shared/LightPlus";
import { useTranslation } from "react-i18next";

type FormatOverrideHeaderProps = {
    name: string;
    onRemove: () => void;
};

/** Shared header for a per-format formula, on a channel or a compensation group. */
const FormatOverrideHeader = ({ name, onRemove }: FormatOverrideHeaderProps) => {
    const [t] = useTranslation();

    return (
        <div className="channel-format-override__header">
            <span className="channel-format-override__title">
                <span>{name}</span>
            </span>
            <LightPlusBtn type="minus" tooltipTitle={t("ConnectTitle.RemoveFormatOverride")} onClick={onRemove} />
        </div>
    );
};

export default FormatOverrideHeader;
